import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { useAlertsStore } from '../../../../../../../stores/websocketStore/_alertsStore';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { DownArrow } from '../../../../../../atomic/atomicComponentLibrary/icons/downArrow/DownArrow';
import { UpArrow } from '../../../../../../atomic/atomicComponentLibrary/icons/upArrow/UpArrow';
import { Body3 } from '../../../../../../atomic/text/Text';
import { determineDistanceToTrigger } from '../../utils/determineDistanceToTrigger';
import { distanceToTriggerGrouping } from '../../utils/distanceToTriggerGrouping';
export const groupingColorMap = {
  1: colors.red,
  2: colors.orange,
  3: colors.yellow,
  4: 'plum',
  5: colors.lightGrey,
};
export const DistanceToTrigger = observer(({ alert, alertId }) => {
  const { priceDataStore } = useWebsocketStore();
  const alertStore = useAlertsStore();
  let isDeactivated = false;
  if (
    alert.restartSystemOncePositionHasFlattened &&
    alert.restartSettings.deactivateOnRestart &&
    alert.restartSettings.deactivated
  )
    isDeactivated = true;
  const sortingDetails = alertStore.alertSortingStore[alertId] ?? null;
  const symbol = alert.symbol;
  const dataSource = alert.dataSource;
  const hash = `${symbol}-${dataSource}`;
  let last = null;
  if (priceDataStore) {
    last = ApplyRounding(priceDataStore?.lastTrade[hash]?.last, 2);
  }
  const [distanceToTrigger, direction] = determineDistanceToTrigger(
    last,
    sortingDetails
  );
  let groupNumber = 5;
  if (distanceToTrigger && distanceToTrigger !== 'none' && last) {
    groupNumber = distanceToTriggerGrouping(distanceToTrigger, last);
  }
  if (isDeactivated) {
    return (
      <td fontWeight={500} color={colors.orange}>
        <Body3>Deactivated</Body3>
      </td>
    );
  }
  return (
    <td>
      <div
        style={{
          minWidth: '60px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Body3 margin="4px 0 0 0" color={groupingColorMap[groupNumber]} fontWeight={500}>
          {distanceToTrigger === 'none' ? 'none' : '$' + distanceToTrigger}
        </Body3>
        {distanceToTrigger !== 'none' ? (
          direction === 'up' ? (
            <UpArrow size="15px" margin="4px 0 0 0"/>
          ) : (
            <DownArrow size="15px" margin="4px 0 0 0"/>
          )
        ) : null}
      </div>
    </td>
  );
});

DistanceToTrigger.propTypes = {
  alert: PropTypes.shape({
    dataSource: PropTypes.any,
    symbol: PropTypes.any,
  }),
  alertId: PropTypes.any,
};
